export type Panel = "layers" | "search";

export const PANEL_IDS: Record<Panel, string> = {
	layers: "map-layers-panel",
	search: "map-search-panel",
};
